/*
 * TestHelden Cookie-Banner (Strom F). Oberfläche für Shopifys Customer Privacy API, siehe snippets/th-cookie-banner.liquid.
 * - zeigt sich nur, wenn Shopify einen Banner verlangt (shouldShowBanner) und noch keine Entscheidung vorliegt
 * - speichert per setTrackingConsent (löst visitorConsentCollected aus, darauf hört assets/th-tracking.js)
 * - „Cookie-Einstellungen“ im Footer (privacyBanner.showPreferences) öffnet die Einstellungen hier
 */
(function () {
  'use strict';
  var wurzel = document.getElementById('th-cc');
  if (!wurzel || window.thCookieBanner) return;
  window.thCookieBanner = 'laedt';

  var ansichten = {
    start: wurzel.querySelector('[data-th-cc-ansicht="start"]'),
    einstellungen: wurzel.querySelector('[data-th-cc-ansicht="einstellungen"]'),
  };
  var schalter = wurzel.querySelectorAll('[data-th-cc-zweck]');
  // Rechtsseiten: nur Hinweisleiste, Seite bleibt bedienbar (keine Scroll-Sperre, keine Fokusfalle, kein Fokus-Sprung)
  var hinweis = wurzel.hasAttribute('data-th-cc-hinweis');
  var abstandAlt = '';
  // Hinweisleiste verdeckt nichts: unten so viel Platz wie die Leiste hoch ist (z. B. Knopf „Widerruf bestätigen“, § 356a BGB)
  function abstandSetzen() {
    if (!hinweis || wurzel.hidden) return;
    document.body.style.paddingBottom = Math.ceil(karte.getBoundingClientRect().height + 24) + 'px';
  }

  function api() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function mitApi(fertig) {
    var erledigt = false;
    function los() {
      if (erledigt || !api()) return false;
      erledigt = true;
      fertig(api());
      return true;
    }
    if (los()) return;
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], los);
    }
    var n = 0;
    (function warten() {
      if (los() || ++n > 40) return;
      setTimeout(warten, 250);
    })();
  }

  var karte = wurzel.querySelector('.th-cc__karte');
  var vorher = null;
  var overflowAlt = '';

  function zeige(ansicht) {
    var warZu = wurzel.hidden;
    ansichten.start.hidden = ansicht !== 'start';
    ansichten.einstellungen.hidden = ansicht !== 'einstellungen';
    wurzel.hidden = false;
    if (warZu && !hinweis) {
      vorher = document.activeElement;
      overflowAlt = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
    }
    if (ansicht === 'start' && !hinweis) karte.focus();
    if (hinweis) {
      if (warZu) abstandAlt = document.body.style.paddingBottom;
      abstandSetzen();
    }
    if (ansicht === 'einstellungen') {
      var cp = api();
      var stand = cp && cp.currentVisitorConsent ? cp.currentVisitorConsent() : {};
      schalter.forEach(function (s) {
        s.checked = stand[s.getAttribute('data-th-cc-zweck') === 'preferences' ? 'preferences' : s.getAttribute('data-th-cc-zweck')] === 'yes';
      });
      var f = wurzel.querySelector('[data-th-cc-fokus]');
      if (f) f.focus();
    }
  }

  function schliessen() {
    wurzel.hidden = true;
    if (!hinweis) document.documentElement.style.overflow = overflowAlt;
    else document.body.style.paddingBottom = abstandAlt;
    if (vorher && typeof vorher.focus === 'function') vorher.focus();
  }

  // Fokus bleibt im Dialog (aria-modal); kein Schließen ohne Entscheidung
  wurzel.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || hinweis) return;
    var ziele = Array.prototype.filter.call(
      karte.querySelectorAll('button, a[href], input'),
      function (el) { return el.offsetParent !== null; }
    );
    if (!ziele.length) return;
    var erstes = ziele[0], letztes = ziele[ziele.length - 1];
    if (e.shiftKey && (document.activeElement === erstes || document.activeElement === karte)) { e.preventDefault(); letztes.focus(); }
    else if (!e.shiftKey && document.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
  });

  function speichern(wahl) {
    mitApi(function (cp) {
      cp.setTrackingConsent(
        { analytics: wahl.analytics, marketing: wahl.marketing, preferences: wahl.preferences, sale_of_data: wahl.marketing },
        function () {}
      );
      schliessen();
    });
  }

  wurzel.addEventListener('click', function (e) {
    var k = e.target.closest('[data-th-cc]');
    if (!k) return;
    var was = k.getAttribute('data-th-cc');
    if (was === 'alle') speichern({ analytics: true, marketing: true, preferences: true });
    else if (was === 'ablehnen') speichern({ analytics: false, marketing: false, preferences: false });
    else if (was === 'einstellungen') zeige('einstellungen');
    else if (was === 'speichern') {
      var wahl = {};
      schalter.forEach(function (s) { wahl[s.getAttribute('data-th-cc-zweck')] = s.checked; });
      speichern(wahl);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !wurzel.hidden && !ansichten.einstellungen.hidden && unentschieden()) zeige('start');
  });

  function unentschieden() {
    var cp = api();
    if (!cp || !cp.currentVisitorConsent) return false;
    var s = cp.currentVisitorConsent();
    return s.analytics === '' || s.marketing === '' || s.preferences === '';
  }

  // Öffentliche Einstiege: Footer-Link und Shopifys privacyBanner
  window.thCookieEinstellungen = function () {
    mitApi(function () { zeige('einstellungen'); });
  };
  var versuche = 0;
  (function footerUmleiten() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences = window.thCookieEinstellungen;
      return;
    }
    if (++versuche < 40) setTimeout(footerUmleiten, 250);
  })();

  window.addEventListener('resize', abstandSetzen);

  mitApi(function (cp) {
    window.thCookieBanner = 'bereit';
    document.documentElement.classList.add('th-cc-aktiv'); // falls der 4-s-Rückfall schon gegriffen hat
    if (cp.shouldShowBanner && cp.shouldShowBanner() && unentschieden()) zeige('start');
  });
})();
